import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CraftingYourHaven from "./sections/CraftingYourHaven";
import OurExpertisePillars from "./sections/OurExpertisePillars";
import TheGreenStandard from "./sections/TheGreenStandard";
import TheTransformationVault from "./sections/TheTransformationVault";
import ClientVoices from "./sections/ClientVoices";
import StartYourProject from "./sections/StartYourProject";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CraftingYourHaven />
      <OurExpertisePillars />
      <TheGreenStandard />
      <TheTransformationVault />
      <ClientVoices />
      <StartYourProject />
      <Footer />
    </div>;
}